// ** Initial user ability
export const initialAbility = [
	{
		action: 'Visualizar',
		subject: 'Home'
	}
];
